module.exports = __webpack_public_path__ + "static/img/sample-pic2.4a739801.png";